import React from 'react';
import { FormField } from 'react-hooks-form';
import TextArea from 'packages/ui/TextAreaField';

function TextAreaFieldWrapper({ onChange, name, value, ...rest }) {
  return (
    <TextArea {...rest} onChange={event => onChange(event.target.value)} value={value || ''} />
  );
}

function TextAreaField({ name, ...rest }) {
  return <FormField {...rest} component={TextAreaFieldWrapper} name={name} />;
}

export default TextAreaField;
